/*
Anonymous
*/
import Status404 from "../classes/homepage/404";
import Home from "../classes/homepage/Home";
import Contacts from "../classes/homepage/Contacts";
import Service from "../classes/homepage/Service";
import ServiceSupport from "../classes/homepage/services/support";
import ServiceBanking from "../classes/homepage/services/banking";
import ServiceCustomizedServices from "../classes/homepage/services/customizedServices";
import Repair from "../classes/homepage/Repair";
import RepairPriceList from "../classes/homepage/repair/priceList";
import RepairPriceQuotation from "../classes/homepage/repair/priceQuotation";
import RepairDatabase from "../classes/homepage/repair/repairDatabase";
import RepairCreateRequest from "../classes/homepage/repair/createRepairRequest";
import Login from "../classes/homepage/Login";
import Register from "../classes/homepage/Register";
import Information from "../classes/homepage/Information";
import Header from "../classes/layout/Header";
import Footer from "../classes/layout/Footer";
import DomainSideBar from "../classes/layout/SideBar/domain";
import UserSideBar from "../classes/layout/SideBar/user";
/*
Anonymous
*/

/* 
Public user router
*/
import UserRepair from "../classes/user/repair";
import UserProfile from "../classes/user/profile";
import UserCreateRequest from "../classes/user/createRequest";
/* 
Public user Routes
*/

/*
VIP routes
*/
import RepairCreateRequestVodafone from "../classes/homepage/repair/vodafone";
import VodafoneAuthorization from "../classes/homepage/repair/vdf_auth";
/*
VIP routes
*/

/*
Domain routes
*/
import DomainS21Reception from "../classes/internal/service/reception";
import DomainS21ItemQr from "../classes/internal/service/ItemQr";
import DomainS21WebCn from "../classes/internal/service/webcn";
import DomainS21WebScan from "../classes/internal/service/webscan";
import DomainWages from "../classes/internal/wages";
import DomainOAuth2 from "../classes/OAuth2";
import DomainS21Vendors from "../classes/internal/service/vendors";
import DomainS21SamsungWhs from "../classes/internal/service/samsung/whs";
import DomainAdminUsers from "../classes/internal/admin/users";
import DomainAdminConstants from "../classes/internal/admin/constants";
import DomainUserReports from "../classes/internal/service/reports";
/*
Domain routes
*/

/*
Integrace API
*/
import SamsungIGSPN from "../classes/internal/serviceapi/samsung_igspn/index";
import O2API from "../classes/internal/serviceapi/o2/index";
import Cariers from "../classes/internal/serviceapi/cariers/index";
/*
Integrace API
*/

const _routes = (props) => {
  //----------------------------------------------
  //-----------------Anonymous user---------------
  //----------------------------------------------
  if (props.element === "Status404") return <Status404 {...props} />;
  if (props.element === "Home") return <Home {...props} />;
  if (props.element === "Contacts") return <Contacts {...props} />;
  if (props.element === "Service") return <Service {...props} />;
  if (props.element === "ServiceSupport") return <ServiceSupport {...props} />;
  if (props.element === "ServiceBanking") return <ServiceBanking {...props} />;
  if (props.element === "ServiceCustomizedServices")
    return <ServiceCustomizedServices {...props} />;
  if (props.element === "Repair") return <Repair {...props} />;
  if (props.element === "RepairPriceList")
    return <RepairPriceList {...props} />;
  if (props.element === "RepairPriceQuotation")
    return <RepairPriceQuotation {...props} />;
  if (props.element === "RepairDatabase") return <RepairDatabase {...props} />;
  if (props.element === "RepairCreateRequest")
    return <RepairCreateRequest {...props} />;
  if (props.element === "Login") return <Login {...props} />;
  if (props.element === "Register") return <Register {...props} />;
  if (props.element === "Information") return <Information {...props} />;
  if (props.element === "Header") return <Header {...props} />;
  if (props.element === "Footer") return <Footer {...props} />;
  if (props.element === "OAuth2") return <DomainOAuth2 {...props} />;
  //----------------------------------------------
  //-----------------Anonymous user---------------
  //----------------------------------------------

  //----------------------------------------------
  //-----------------Domain-----------------------
  //----------------------------------------------
  if (props.element === "DomainSideBar") return <DomainSideBar {...props} />;
  if (props.element === "Servis21Vendors")
    return <DomainS21Vendors {...props} />;
  if (props.element === "Servis21WebCN") return <DomainS21WebCn {...props} />;
  if (props.element === "Servis21WebScan") return <DomainS21WebScan {...props} />;
  if (props.element === "AdminConstants")
    return <DomainAdminConstants {...props} />;
  if (props.element === "AdminUsers") return <DomainAdminUsers {...props} />;
  if (props.element === "Servis21QRCodeArticle")
    return <DomainS21ItemQr {...props} />;
  if (props.element === "Servis21Reception")
    return <DomainS21Reception {...props} />;
  if (props.element === "Wages") return <DomainWages {...props} />;
  if (props.element === "SamsungIGSPN") return <SamsungIGSPN {...props} />;
  if (props.element === "O2Api") return <O2API {...props} />;
  if (props.element === "Cariers") return <Cariers {...props} />;
  if (props.element === "UserReports") return <DomainUserReports {...props} />;
  if (props.element === "Servis21SamsungWhs")
    return <DomainS21SamsungWhs {...props} />;
  //----------------------------------------------
  //-----------------Domain-----------------------
  //----------------------------------------------

  //----------------------------------------------
  //-----------------Public user------------------
  //----------------------------------------------
  if (props.element === "UserRepair") return <UserRepair {...props} />;
  if (props.element === "UserProfile") return <UserProfile {...props} />;
  if (props.element === "UserCreateRequest")
    return <UserCreateRequest {...props} />;
  if (props.element === "UserSideBar") return <UserSideBar {...props} />;
  //----------------------------------------------
  //-----------------Public user------------------
  //----------------------------------------------

  //----------------------------------------------
  //-----------------VIP user---------------------
  //----------------------------------------------
  if (props.element === "RepairCreateRequestVodafone")
    return <RepairCreateRequestVodafone {...props} />;
  if (props.element === "VodafoneAuthorization")
    return <VodafoneAuthorization {...props} />;
  //----------------------------------------------
  //-----------------VIP user---------------------
  //----------------------------------------------

  //----------------------------------------------
  //-----------------VIP user---------------------
  //----------------------------------------------
  if (props.element === "RepairCreateRequestVodafone")
    return <RepairCreateRequestVodafone {...props} />;
  if (props.element === "VodafoneAuthorization")
    return <VodafoneAuthorization {...props} />;
  //----------------------------------------------
  //-----------------VIP user---------------------
  //----------------------------------------------
  return null;
};

export default _routes;
